// extracted by mini-css-extract-plugin
module.exports = {"item":"CheckedLine_item__2iPOn","itemText":"CheckedLine_itemText__1Ksre"};